module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="social-bnt-frame">\r\n	<a href="https://twitter.com/share" class="twitter-share-button">Tweet</a>\r\n</div>\r\n';
}
return __p;
};
